import { useEffect } from "react";
import { useProgress } from "../../context/ProgressContext";
import BookmarkButton from "../../components/BookmarkButton";
import SectionCompleteBar from "../../components/SectionCompleteBar";
import MultipleIntegralsGuide from "./MultipleIntegralsGuide";
import "./GuidePart.css";

function IntegralsPart2() {
  const { recordVisit } = useProgress();

  useEffect(() => {
    recordVisit("integrals-2");
  }, [recordVisit]);

  return (
    <div className="guide-part-wrapper">
      <div className="guide-part-topbar">
        <div className="guide-part-info">
          <span className="guide-part-badge">Section 2</span>
          <span className="guide-part-title">
            Multiple Integrals — Polar, Cylindrical & Spherical Coordinates
          </span>
        </div>
        <BookmarkButton
          id="integrals-2"
          title="Multiple Integrals — Section 2"
          path="/multiple-integrals/2"
        />
      </div>
      <MultipleIntegralsGuide part={2} />
      <SectionCompleteBar
        sectionId="integrals-2"
        nextPath="/lagrange-multipliers/1"
        nextLabel="Next: Lagrange Multipliers"
      />
    </div>
  );
}

export default IntegralsPart2;
